<mat-sidenav-container style="background-color: #533f03">
	<mat-sidenav #appSidenav mode="over" position="start" class="app-sidenav">
		<app-sidenav (onSideNvaAction)="onSideNvaAction($event)" [sideNav]="appSidenav" workMode="tabitPay"></app-sidenav>
	</mat-sidenav>
	<div class="module-content">
		<div class="_top">
			<img src="assets/images/logo-white.svg" style="height: 25px">
			@if (appService.user) {
				<button class="_fab" mat-mini-fab color="accent" (mousedown)="toggleAppSidenav()" style="box-shadow:none">
					{{appService.user.initials}}
				</button>
			} @else {
				<button class="_fab" mat-mini-fab color="accent" (mousedown)="toggleAppSidenav()" style="box-shadow:none">
					<mat-icon svgIcon="bars"></mat-icon>
				</button>
			}
			<!--@if (message?.animation) {
				<lottie-anim [options]="{animation: message.animation, autoplay: true, loop: true}"
							 [height]="128"></lottie-anim>
			}-->
		</div>

		<div class="_body ">

			@if (mode == 'inApp') {
				<div style="padding: 2rem">

					@if (!appService.user) {

						<div class="_app-header" (click)="this.handleOpenQRScanner()">
							<div class="text-xl font-weight-bolder text-accent pre-wrap">{{ '_APP.open-cam-prompt' | translate }}</div>
							<div class="text-md pre-wrap">{{ '_APP.open-cam-desc' | translate }}</div>
						</div>

						@if (inAppService.config.isWrapper) {
							<div class="text-center" (click)="this.handleOpenQRScanner()">
								<img src="assets/images/scan_qr.png" style="height: 200px; object-fit: scale-down; opacity: 0.2; border-radius: 15px; margin-bottom: 3rem;"/>
							</div>
						} @else {
							<div class="text-center">
								<img src="assets/images/scan_qr.png" style="height: 200px; object-fit: scale-down; opacity: 0.2; border-radius: 15px; margin-bottom: 3rem;"/>
							</div>
						}

						<button mat-flat-button color="accent" class="lg rounded btn-block pre-wrap"
								style="height:auto; padding:15px" type="button" (mousedown)="login()">
							<b>{{ '_APP.login-prompt' | translate }}</b>
						</button>
					} @else {

						<div class="_app-header animated fadeIn">
							<div class="text-lg font-weight-bolder pre-wrap">{{ 'WELCOME_BACK' | translate: {name: appService.user.name} }}</div>
							@if (inAppService.config.isWrapper) {
								<div class="_scan-banner bg-accent"  (click)="this.handleOpenQRScanner()">
									<img src="assets/images/scan_qr_light.png"/>
									<div class="text-md pre-wrap">{{ '_APP.scan-qr-signed' | translate }}</div>
								</div>
							} @else {
								<div class="text-md pre-wrap" (click)="loadFromScanURL()">{{ '_APP.open-cam-desc-signed' | translate }}</div>
							}
						</div>

						@if (loading) {
							<div class="_load-animate _load-active"></div>
						} @else if (history) {
							<div class="animated fadeInUp">
								<hr style="border-top-width: 3px">
								<div class="text-md font-weight-bolder mb-3">{{ '_APP.recent-sites' |  translate }}
								</div>
								<div class="_sites" [class.j-center]="history.sites.length > 2">
									@for (site of history.sites | slice: 0: 3; track site._id) {
										<div (mousedown)="gotoSite(site.organization)">
											<div class="_image"><img
												[src]="site.logo || '/assets/images/restaurant-logo-not-found.png'"/>
											</div>
											<div class="_name font-semi-bold text-accent">{{ site.name }}</div>
										</div>
									}
								</div>

								<hr style="border-top-width: 3px">
								<div class="text-md font-weight-bolder mb-3">{{ '_APP.recent-orders' |  translate }}
								</div>
								<div class="generic-list">

									@for (order of history.orders | slice: 0 : history.end; track order._id) {
										<div class="generic-list-item " (click)="historyClick(order, $event)"
											 [class.active]="order._offers">
											<!--<div><img [src]="order._o.img"></div>-->

											<div class="_content">
												<div class="font-weight-bold"> {{ order.name }}</div>
												<div class="_line">
													<span class="inline">{{ order.serviceType | translate }}</span>
													<span class="inline px-1">&bull;</span>
													<span class="inline">{{ order.date | ldate }}</span>
													<span class="inline px-1">&bull;</span>
													<span class="inline">{{ order.amount | lcurrency }}</span>
												</div>
												@if (order._offers) {
													<div class="txt-color-light _offers ">
														@for (offer of order._offers; track offer) {
															<div><span *ngIf="offer.count > 1">{{ offer.count }}*</span><span>{{ offer.name }}</span>
															</div>
														}
													</div>
												} @else if (order._loading) {
													<div class="text-accent _offers">
														<div>{{ 'loading_order_details' | translate }}</div>
													</div>
												}
											</div>
											<mat-icon>more_vert</mat-icon>
										</div>
										<hr>
									}
								</div>

								@if (history.hasNext) {
									<button mat-stroked-button color="accent" class="lg rounded btn-block mt-3"
											style="" type="button" (mousedown)="setOrdersPage(1)">
										{{ 'load_more_orders' | translate }}
									</button>
								}</div>


						} @else {
							<hr>
							<div class="_app-header animated fadeIn">
								<div class="font-weight-bolder pre-wrap">{{ '_APP.no-orders-title' | translate }}</div>

								<div class="text-center py-3"><img src="assets/images/dish-cover.png" style="width:97px; height: 80px;"/></div>

								<div class="pre-wrap">{{ '_APP.no-orders-desc' | translate }}</div>
							</div>
						}
					}
				</div>
			} @else {
				<div class="_body-links">
					<!--START ANONIMUS IN USER-->
					<ng-container *ngIf="!appService.user && appService.enableLogin">
						<div class="_link" matRipple (click)="dialogsService.login(null, 'infoPage')">
                      <span class="_icon">
                          <mat-icon svgIcon="signin"></mat-icon>
                      </span>
							<div>
								{{ 'sign_in_nav' | translate }}
								<small></small>
							</div>
							<mat-icon class="lg">more_horiz</mat-icon>
						</div>
					</ng-container>
					<!--END ANONIMUS IN USER-->
					<!--START SIGNED IN USER-->
					<ng-container *ngIf="appService.user">

						<div class="_link" matRipple (click)="dialogsService.showAccount()">
                      <span class="_icon">
                          <mat-icon svgIcon="info_square"></mat-icon>
                      </span>
							<div>
								{{ 'my_account' | translate }}
								<small></small>
							</div>
							<mat-icon class="lg">{{ appService.nextIcon }}</mat-icon>
						</div>
						<div class="_link" matRipple (click)="dialogsService.showHistory()">
                      <span class="_icon">
                          <mat-icon svgIcon="history"></mat-icon>
                      </span>
							<div>
								{{ 'my_history' | translate }}
								<small>{{ 'my_history_info' | translate }}</small>
							</div>
							<mat-icon class="lg">{{ appService.nextIcon }}</mat-icon>
						</div>
						@if (appService.regionArgs.enableWallet) {
							<div class="_link" (click)="dialogsService.showWallet()">
                    <span class="_icon">
                        <mat-icon svgIcon="check_alt"></mat-icon>
                    </span>
								<div>
									{{ 'my_wallet' | translate }}
									<small>{{ 'my_wallet_info' | translate }}</small>
								</div>
								<mat-icon class="lg">{{ appService.nextIcon }}</mat-icon>
							</div>
						}
					</ng-container>
				</div>
			}
		</div>
	</div>

</mat-sidenav-container>
